import { Routes } from '@angular/router';
import { hasPermissionToLoadGuard } from './guards/has-permission-to-load.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/login/login.routes').then((m) => m.routes),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.routes),
    data: { title: 'Kontrolna ploča', subtitle: 'Dobro došli' },
    title: 'Kontrolna ploča',
  },
  {
    path: 'category-list',
    loadChildren: () =>
      import('./pages/category/category-list/category-list.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Kategorije',
      subtitle: 'Sve kategorije',
      requiredPermission: 'view_any_category',
    },
    title: 'Sve kategorije',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'category-add-edit',
    loadChildren: () =>
      import(
        './pages/category/category-add-edit/category-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Kategorije',
      subtitle: 'Nova kategorija',
      requiredPermission: 'create_category',
    },
    title: 'Nova kategorija',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'category-add-edit/:id',
    loadChildren: () =>
      import(
        './pages/category/category-add-edit/category-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Kategorije',
      subtitle: 'Nova kategorija',
      requiredPermission: 'update_category',
    },
    title: 'Uredi kategoriju',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'home-page-structure',
    loadChildren: () =>
      import('./pages/home-page-structure/home-page-structure.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Naslovna strana',
      subtitle: 'Naslovna strana',
      requiredPermission: 'view_any_template_collection',
    },
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'breaking-news',
    loadChildren: () =>
      import('./pages/breaking-news/breaking-news.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Udarne vijesti',
      subtitle: 'Udarne vrijesti',
      requiredPermission: 'view_any_website_notification',
    },
    title: 'Udarne vijesti',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'document-list',
    loadChildren: () =>
      import('./pages/documents/document-list/document-list.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Dokumenti',
      subtitle: 'Svi dokumenti',
      requiredPermission: 'view_any_file',
    },
    title: 'Sve dokumenti',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'document-add-edit',
    loadChildren: () =>
      import(
        './pages/documents/document-add-edit/document-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Dokument',
      subtitle: 'Dodaj dokument',
      requiredPermission: 'create_file',
    },
    title: 'Dodaj dokument',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'document-add-edit/:id',
    loadChildren: () =>
      import(
        './pages/documents/document-add-edit/document-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Dokument',
      subtitle: 'Uredi dokument',
      requiredPermission: 'update_file',
    },
    title: 'Uredi dokument',
    canActivate: [hasPermissionToLoadGuard],
  },

  {
    path: 'image-list',
    loadChildren: () =>
      import('./pages/images/image-list/image-list.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Slike',
      subtitle: 'Sve slike',
      requiredPermission: 'view_any_image',
    },
    title: 'Sve slike',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'image-add-edit',
    loadChildren: () =>
      import('./pages/images/add-edit-image/add-edit-image.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Slike',
      subtitle: 'Dodaj sliku',
      requiredPermission: 'create_image',
    },
    title: 'Dodaj sliku',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'image-add-edit/:id',
    loadChildren: () =>
      import('./pages/images/add-edit-image/add-edit-image.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Slike',
      subtitle: 'Uredi sliku',
      requiredPermission: 'update_image',
    },
    title: 'Uredi sliku',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'gallery-list',
    loadChildren: () =>
      import('./pages/gallery/gallery-list/gallery-list.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Galerija',
      subtitle: 'Sve galerije',
      requiredPermission: 'view_any_gallery',
    },
    title: 'Sve galerije',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'gallery-add-edit',
    loadChildren: () =>
      import('./pages/gallery/gallery-add-edit/gallery-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Galerija',
      subtitle: 'Dodaj galeriju',
      requiredPermission: 'create_gallery',
    },
    title: 'Dodaj galeriju',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'gallery-add-edit/:id',
    loadChildren: () =>
      import('./pages/gallery/gallery-add-edit/gallery-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Galerija',
      subtitle: 'Uredi galeriju',
      requiredPermission: 'update_gallery',
    },
    title: 'Uredi galeriju',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'poll-list',
    loadChildren: () =>
      import('./pages/poll/poll-list/poll-list.routes').then((m) => m.routes),
    data: {
      title: 'Ankete',
      subtitle: 'Sve ankete',
      requiredPermission: 'view_any_poll',
    },
    title: 'Sve galerije',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'poll-add-edit',
    loadChildren: () =>
      import('./pages/poll/poll-add-edit/poll-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Anketa',
      subtitle: 'Dodaj anketu',
      requiredPermission: 'create_poll',
    },
    title: 'Dodaj anketu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'poll-add-edit/:id',
    loadChildren: () =>
      import('./pages/poll/poll-add-edit/poll-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Anketa',
      subtitle: 'Uredi anketu',
      requiredPermission: 'update_poll',
    },
    title: 'Uredi anketu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'login',
    title: 'Prijava',
    loadChildren: () =>
      import('./pages/login/login.routes').then((m) => m.routes),
  },

  {
    path: 'menu-main',
    loadChildren: () =>
      import('./pages/menu/main/main.routes').then((m) => m.routes),
    data: {
      title: 'Menu',
      subtitle: 'Uredi glavni menu',
      requiredPermission: 'view_any_menu',
    },
    title: 'Uredi glavni menu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'menu-footer',
    loadChildren: () =>
      import('./pages/menu/footer-menu/footer-menu.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Menu',
      subtitle: 'Uredi footer menu',
      requiredPermission: 'view_any_menu',
    },
    title: 'Uredi footer menu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'post-list',
    loadChildren: () =>
      import('./pages/post/post-list/post-list.routes').then((m) => m.routes),
    data: {
      title: 'Članci',
      subtitle: 'Svi članci',
      requiredPermission: 'view_any_article',
    },
    title: 'Svi članci',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'post-add-edit',
    loadChildren: () =>
      import('./pages/post/post-add-edit/post-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Članak',
      subtitle: 'Dodaj članak',
      requiredPermission: 'create_article',
    },
    title: 'Dodaj članak',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'post-add-edit/:id',
    loadChildren: () =>
      import('./pages/post/post-add-edit/post-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Članak',
      subtitle: 'Dodaj članak',
      requiredPermission: 'update_article',
    },
    title: 'Uredi članak',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'source-list',
    loadChildren: () =>
      import('./pages/sources/source-list/source-list.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Izvori',
      subtitle: 'Svi izvori',
      requiredPermission: 'view_any_source',
    },
    title: 'Svi izvori',
    canActivate: [hasPermissionToLoadGuard],
  },

  {
    path: 'source-add-edit',
    loadChildren: () =>
      import('./pages/sources/source-add-edit/source-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Izvori',
      subtitle: 'Kreiraj izvor',
      requiredPermission: 'create_source',
    },
    title: 'Kreiraj izvor',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'source-add-edit/:id',
    loadChildren: () =>
      import('./pages/sources/source-add-edit/source-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Izvori',
      subtitle: 'Izmjeni izvor',
      requiredPermission: 'update_source',
    },
    title: 'Izmjeni izvor',
    canActivate: [hasPermissionToLoadGuard],
  },

  {
    path: 'static-page-list',
    loadChildren: () =>
      import(
        './pages/static-pages/static-page-list/static-page-list.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Stranice',
      subtitle: 'Sve stranice',
      requiredPermission: 'view_any_page',
    },
    title: 'Sve stranice',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'static-page-add-edit',
    loadChildren: () =>
      import(
        './pages/static-pages/static-page-add-edit/static-page-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Stranice',
      subtitle: 'Kreiraj stranicu',
      requiredPermission: 'create_page',
    },
    title: 'Kreiraj stranicu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'static-page-add-edit/:id',
    loadChildren: () =>
      import(
        './pages/static-pages/static-page-add-edit/static-page-add-edit.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Stranice',
      subtitle: 'Kreiraj stranicu',
      requiredPermission: 'update_page',
    },
    title: 'Izmjeni stranicu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'tag-list',
    loadChildren: () =>
      import('./pages/tag/tag-list/tag-list.routes').then((m) => m.routes),
    data: {
      title: 'Tagovi',
      subtitle: 'Svi tagovi',
      requiredPermission: 'view_any_tag',
    },
    title: 'Svi tagovi',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'tag-add-edit',
    loadChildren: () =>
      import('./pages/tag/tag-add-edit/tag-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Tagovi',
      subtitle: 'Kreiraj tag',
      requiredPermission: 'create_tag',
    },
    title: 'Kreiraj tag',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'tag-add-edit/:id',
    loadChildren: () =>
      import('./pages/tag/tag-add-edit/tag-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Tagovi',
      subtitle: 'Kreiraj tag',
      requiredPermission: 'update_tag',
    },
    title: 'Izmjeni tag',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'banner-list',
    loadChildren: () =>
      import('./pages/banner/banner-list/banner.routes').then((m) => m.routes),
    data: {
      title: 'Baneri',
      subtitle: 'Svi Baneri',
      requiredPermission: 'view_any_banner',
    },
    title: 'Svi Baneri',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'banner-add-category-page',
    loadChildren: () =>
      import(
        './pages/banner/banner-add-category-page/banner-add.category-page.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Baneri za kategorije',
      subtitle: 'Kreiraj banere za kategorije',
      requiredPermission: 'create_banner',
    },
    title: 'Kreiraj banere',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'banner-add-single-page',
    loadChildren: () =>
      import(
        './pages/banner/banner-add-single-page/banner-add-single-page.routes'
      ).then((m) => m.routes),
    data: {
      title: 'Baneri za kategorije',
      subtitle: 'Kreiraj banere za kategorije',
      requiredPermission: 'create_banner',
    },
    title: 'Kreiraj banere',
    canActivate: [hasPermissionToLoadGuard],
  },

  {
    path: 'user-list',
    loadChildren: () =>
      import('./pages/user/user-list/user-list.routes').then((m) => m.routes),
    data: {
      title: 'Korisnici',
      subtitle: 'Svi korisnici',
      requiredPermission: 'view_any_user',
    },
    title: 'Svi korisnici',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'user-add-edit',
    loadChildren: () =>
      import('./pages/user/user-add-edit/user-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Korisnici',
      subtitle: 'Dodaj korisnika',
      requiredPermission: 'create_user',
    },
    title: 'Dodaj korisnika',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'user-add-edit/:id',
    loadChildren: () =>
      import('./pages/user/user-add-edit/user-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Korisnici',
      subtitle: 'Dodaj korisnika',
      requiredPermission: 'update_user',
    },
    title: 'Uredi korisnika',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'me-add-edit/:id',
    loadChildren: () =>
      import('./pages/user/user-add-edit/user-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Korisnici',
      subtitle: 'Dodaj korisnika',
      requiredPermission: 'update_profile',
    },
    title: 'Uredi korisnika',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'role-list',
    loadChildren: () =>
      import('./pages/role/role-list/role-list.routes').then((m) => m.routes),
    data: {
      title: 'Uloge',
      subtitle: 'Sve uloge',
      requiredPermission: 'view_any_role',
    },
    title: 'Sve uloge',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'role-add-edit',
    loadChildren: () =>
      import('./pages/role/role-add-edit/role-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Uloge',
      subtitle: 'Dodaj ulogu',
      requiredPermission: 'create_role',
    },
    title: 'Dodaj ulogu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'role-add-edit/:id',
    loadChildren: () =>
      import('./pages/role/role-add-edit/role-add-edit.routes').then(
        (m) => m.routes
      ),
    data: {
      title: 'Uloge',
      subtitle: 'Izmjeni ulogu',
      requiredPermission: 'update_role',
    },
    title: 'Izmjeni ulogu',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: 'comments',
    loadChildren: () =>
      import('./pages/comments/comments.routes').then((m) => m.routes),
    data: {
      title: 'Komentari',
      subtitle: 'Svi komentari',
      requiredPermission: 'view_any_article_comment',
    },
    title: 'Svi komentari',
    canActivate: [hasPermissionToLoadGuard],
  },
  {
    path: '**',
    loadChildren: () =>
      import('./pages/page-not-found/page-not-found.routes').then(
        (m) => m.routes
      ),
  },
];
